export default "__VITE_ASSET__Coe6baEm__"